import { Helmet } from 'react-helmet';
import SimsoDetail
  from 'src/components/simso-detail/SimsoDetail';

import {
  Box,
  Container,
} from '@material-ui/core';

import SimsoListToolbar from '../components/simso-detail/SimsoToolbar';

const Simso = () => (
  <>
    <Helmet>
      <title>Quản lý sim số</title>
    </Helmet>
    <Box
      sx={{
        backgroundColor: 'background.default',
        minHeight: '100%',
        py: 3
      }}
    >
      <Container style={{maxWidth: "100%"}}>
        <SimsoListToolbar />
        <Box sx={{ pt: 3 }}>
          <SimsoDetail />
        </Box>
      </Container>
    </Box>
  </>
);

export default Simso;
